import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IUploadedFile } from "../models/interfaces";

type GroundingStatus = "idle" | "queued" | "building" | "completed" | "cleared" | "degraded" | "failed";

interface GroundingJob {
  status: GroundingStatus;
  total?: number;
  completed?: number;
  failed?: number;
}

interface ChatState {
  activeChatId: string | null;
  selectedPersonaId: string;
  isSending: boolean;
  saveModalOpen: boolean;
  saveTitle: string;
  groundingJob: GroundingJob;
  uploadedFilesByChatId: Record<string, IUploadedFile>;
  isUploading: boolean;
}

export const initialState: ChatState = {
  activeChatId: null,
  selectedPersonaId: "",
  isSending: false,
  saveModalOpen: false,
  saveTitle: "",
  groundingJob: { status: "idle" },
  uploadedFilesByChatId: {},
  isUploading: false,
};

const chatSlice = createSlice({
  name: "chatSlice",
  initialState,
  reducers: {
    setActiveChatId: (state, action: PayloadAction<string | null>) => {
      state.activeChatId = action.payload;
    },
    setSelectedPersonaId: (state, action: PayloadAction<string>) => {
      state.selectedPersonaId = action.payload;
    },
    setIsSending: (state, action: PayloadAction<boolean>) => {
      state.isSending = action.payload;
    },
    setSaveModalOpen: (state, action: PayloadAction<boolean>) => {
      state.saveModalOpen = action.payload;
    },
    setSaveTitle: (state, action: PayloadAction<string>) => {
      state.saveTitle = action.payload;
    },
    setGroundingJob: (state, action: PayloadAction<GroundingJob>) => {
      state.groundingJob = action.payload;
    },
    setUploadedFile: (
      state,
      action: PayloadAction<{ chatId: string; uploadedFile: IUploadedFile | null }>
    ) => {
      if (action.payload.uploadedFile) {
        state.uploadedFilesByChatId[action.payload.chatId] = action.payload.uploadedFile;
      } else {
        delete state.uploadedFilesByChatId[action.payload.chatId];
      }
    },
    setIsUploading: (state, action: PayloadAction<boolean>) => {
      state.isUploading = action.payload;
    },
    resetChat: () => initialState,
  },
});

export const {
  resetChat,
  setActiveChatId,
  setGroundingJob,
  setIsSending,
  setIsUploading,
  setSaveModalOpen,
  setSaveTitle,
  setSelectedPersonaId,
  setUploadedFile,
} = chatSlice.actions;
export default chatSlice.reducer;
